
import { BoxType, Material, Shipping, Violation } from '@company-box/models';
import { ISerializable } from './base';

export class Tissue implements ISerializable<Tissue> {

    material: Material | undefined;
    price: TissuePrice | undefined;
    paper: string | undefined;
    violations: Violation[] = [];
    type: BoxType | undefined;

    deserialize(input: any): Tissue {

        if (input.material) {
            this.material = new Material().deserialize(input.material);
        }
        if (input.price) {
            this.price = new TissuePrice().deserialize(input.price);
        }
        this.paper = input.paper;
        this.material = input.material;
        this.violations = [];
        if (input.constraintViolations) {
            input.constraintViolations.forEach((value: any) => {
                const violation = new Violation().deserialize(value);
                this.violations.push(violation);
            });
        }
        if (input.type) {
            this.type = new BoxType().deserialize(input.type);
        }
        return this;
    }
}

export class TissueDimensions implements ISerializable<TissueDimensions> {
    reamLength: number | undefined;
    reamWidth: number | undefined;
    reamDepth: number | undefined;
    weight: number | undefined;

    deserialize(input: any): TissueDimensions {
        this.reamLength = input.reamLength;
        this.reamWidth = input.reamWidth;
        this.reamDepth = input.reamDepth;
        this.weight = input.weight;
        return this;
    }
}

export class TissuePrice implements ISerializable<TissuePrice> {
    pricePerReam: number | undefined;
    pricePerSheet: number | undefined;
    totalPrice: number | undefined;
    minimumOrder: number | undefined;
    maxQuantity: number | undefined;
    quantity: number | undefined;
    manufacturingPricePerReam: string | undefined;
    dimensions: TissueDimensions | undefined;
    shipping: Shipping | undefined;

    deserialize(input: any): TissuePrice {
        this.pricePerReam = input.pricePerReam;
        this.totalPrice = input.totalPrice;
        this.minimumOrder = input.minimumOrder;
        this.maxQuantity = input.maxQuantity;
        this.quantity = input.quantity;
        this.pricePerSheet = input.pricePerSheet;
        this.manufacturingPricePerReam = input.manufacturingPricePerReam;
        if (input.dimensions) {
            this.dimensions = new TissueDimensions().deserialize(input.dimensions);
        }
        if (input.shipping) {
            this.shipping = new Shipping().deserialize(input.shipping);
        }
        return this;
    }
}

export class TissuePricingResponse implements ISerializable<TissuePricingResponse> {
    prices: TissuePrice[] = [];
    tissue: Tissue | undefined;

    deserialize(input: any): TissuePricingResponse {
        this.prices = [];
        if (input.prices) {
            input.prices.forEach((value: any) => {
                if (value) {
                    const price = new TissuePrice().deserialize(value);
                    this.prices.push(price);
                }
            });
        }
        if (input.tissue) {
            this.tissue = new Tissue().deserialize(input.tissue);
        }
        return this;
    }
}
